import React from 'react'
import {
    Accordion,
    AccordionHeader,
    AccordionBody,
} from "@material-tailwind/react";
import TreatmentUsableItemsList from '../list/CategoriesItemsList';

const TreatmentCategoriesAccordion = ({ AccordionData }) => {

    const [open, setOpen] = React.useState(0);

    const handleOpen = (value) => setOpen(open === value ? 0 : value);

    function Icon({ id, open }) {
        return (
            <svg
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
        );
    }

    return (
        <>

            {AccordionData.map((rowData) =>
                <Accordion key={rowData.equipmentId} open={open === rowData.equipmentId} icon={<Icon id={rowData.equipmentId} open={open} />} className="mb-2 rounded-lg border border-blue-gray-100 px-4">
                    <AccordionHeader
                        onClick={() => handleOpen(rowData.equipmentId)}
                        className={`border-b-0 p-2 transition-colors text-md text_OpenSans-VariableFont_wdth
                        ${open === rowData.equipmentId ? "text-green-700 hover:!text-green-500" : ""}`}
                    >
                        {rowData.equipmentName}
                    </AccordionHeader>
                    <AccordionBody className="py-0 leading-tight font-normal  description_AlegreyaSans-Light">
                        {rowData.description}
                        <TreatmentUsableItemsList equipmentListData={rowData.equipmentItem} />
                    </AccordionBody>
                </Accordion>
            )}

        </>
    )
}

export default TreatmentCategoriesAccordion